/**
 * Helper class containing parse functions.
 *
 * @class
 *
 **/
class TournamentParser {

    static parse(cfg) {
        const timestamp = cfg.bridge.timestamp;
        const rgi = cfg.server.rgsApi;

        if (!cfg.tournament) {
            cfg.tournament = {
                enabled: false,
                basePath: `${cfg.game.preconfig.cdn}../../widgets/base-tournament/`,
                main: 'app.min.js',
                styles: 'app.min.css',
                timestamp,
                skin: 'base-tournament',
                leaderboardUrl: `${rgi}tournaments/leaderboard/`,
            };
        }

        if (!cfg.tournament.timestamp) {
            cfg.tournament.timestamp = timestamp;
        }

        return cfg.tournament;
    }

}


module.exports = TournamentParser;
